import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import { Sidebar } from "semantic-ui-react";

import "./Sidebar.scss";

import { signOut, getUserDataAsync } from '../../../redux/actions/auth';
import { toggleMenuHelper } from '../../../redux/actions/ui';

const mapStateToProps = state => ({
  userLogin: state.auth.userLogin,
  menuHelper: state.ui.menuHelper,
});

const mapDispatchToProps = dispatch => ({
  logOut: () => dispatch(signOut()),
  getUserData: () => dispatch(getUserDataAsync()),
  toggleMenuHelper: () => dispatch(toggleMenuHelper()),
});

class SidebarBlock extends Component {
  static propTypes = {
    userLogin: PropTypes.string.isRequired,
    menuHelper: PropTypes.object.isRequired,
    logOut: PropTypes.func.isRequired,
    getUserData: PropTypes.func.isRequired,
    toggleMenuHelper: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { getUserData } = this.props;
    getUserData();
  }

  render() {
    const { userLogin, menuHelper, logOut, toggleMenuHelper } = this.props;

    const expandClass = classnames({
      'expand': true,
      'more': !menuHelper.isOpen,
      'less': menuHelper.isOpen,
    });

    return (
      <Sidebar className="aside" vertical="true" visible width="thin">
        <div className="sidebar-logo" />
          <ul className="nav">
              <li>
                  <NavLink
                      to={'/clients'}
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/client/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Клиенты</div>
                      </div>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to="/consultants"
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/consultant/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Консультанты</div>
                      </div>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to="/polls"
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/(poll|edit-poll|create-poll)/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Опросы</div>
                      </div>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to="/templates"
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/(template|edit-template|create-template)/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Шаблоны</div>
                      </div>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to="/analytics"
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/analytics/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Аналитика</div>
                      </div>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to="/blocked-phones"
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/blocked-phones/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Разблокировка телефонов</div>
                      </div>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to="/localizations"
                      isActive={(match, location) => {
                          if (location.pathname.match(/^\/localizations/)) return true;
                          return false;
                      }}
                  >
                      <div className="link-wrap">
                          <div className="right-border"/>
                          <div className="link-text">Локализация</div>
                      </div>
                  </NavLink>
              </li>
              <li className="nav-expand">
                  <div className="link-wrap">
                      <div className="link-text" onClick={() => toggleMenuHelper()}>
                          <span>Помощник</span>
                          <div className={expandClass}/>
                      </div>
                  </div>
                  {menuHelper.isOpen ? (
                      <ul className="nav-level2">
                          <li>
                              <NavLink
                                  to="/messages"
                                  isActive={(match, location) => {
                                      if (location.pathname.match(/^\/(message|edit-message|create-message)/)) return true;
                                      return false;
                                  }}
                              >
                                  <div className="link-wrap">
                                      <div className="right-border"/>
                                      <div className="link-text">Сообщения</div>
                                  </div>
                              </NavLink>
                          </li>
                          <li>
                              <NavLink
                                  to="/questions"
                                  isActive={(match, location) => {
                                      if (location.pathname.match(/^\/(question|edit-question|create-question)/)) return true;
                                      return false;
                                  }}
                              >
                                  <div className="link-wrap">
                                      <div className="right-border"/>
                                      <div className="link-text">Вопросы</div>
                                  </div>
                              </NavLink>
                          </li>
                      </ul>
                  ) : false}
              </li>
          </ul>
          <div className="sidebar-logout">
              <button type="button" className="logout-btn" onClick={() => logOut()}>Выйти</button>
              <div className="logout-user">{userLogin}</div>
          </div>
      </Sidebar>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarBlock);
